import { Star, StarHalf } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "./Motion";

const GOOGLE_URL = "https://share.google/Io1ToIhMLgxdS8bsL";

const GoogleG = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
    <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
  </svg>
);

const reviews = [
  { name: "Sarah M.", text: "Best butter chicken in Ottawa, hands down. We've been coming here for years and it never disappoints." },
  { name: "David L.", text: "Catered our office party and everyone raved about the food. So easy to deal with and generous portions." },
  { name: "Priya S.", text: "Authentic, fresh and full of flavour. The staff treat you like family every single time." },
];

export default function GoogleReviews() {
  return (
    <section className="bg-[#141414] border-y border-white/10" data-testid="google-reviews">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-24">
        <Reveal className="flex flex-col items-center text-center mb-12">
          <div className="flex items-center gap-3 mb-4">
            <GoogleG size={34} />
            <span className="font-display text-2xl md:text-3xl font-semibold text-white">Google Reviews</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="font-display font-bold text-5xl text-[#ffd100]">4.5</span>
            <div className="flex flex-col items-start">
              <div className="flex text-[#ffd100]">
                {[0, 1, 2, 3].map((i) => <Star key={i} size={22} className="fill-[#ffd100]" />)}
                <StarHalf size={22} className="fill-[#ffd100]" />
              </div>
              <span className="text-neutral-300 text-base mt-1">Rated by <span className="text-white font-semibold">500+</span> happy customers</span>
            </div>
          </div>
        </Reveal>

        <StaggerGroup className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <StaggerItem key={r.name}>
              <div className="bg-[#0a0a0a] border border-white/10 rounded-2xl p-7 h-full flex flex-col">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex text-[#ffd100]">
                    {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={18} className="fill-[#ffd100]" />)}
                  </div>
                  <GoogleG size={22} />
                </div>
                <p className="text-neutral-200 text-lg leading-relaxed flex-1">&ldquo;{r.text}&rdquo;</p>
                <p className="mt-5 font-display font-semibold text-white text-lg">{r.name}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        <Reveal className="text-center mt-10">
          <a href={GOOGLE_URL} target="_blank" rel="noreferrer" data-testid="google-reviews-btn"
            className="inline-flex items-center gap-3 bg-white text-[#0a0a0a] font-bold text-lg px-7 py-4 rounded-full hover:bg-neutral-200 transition-colors">
            <GoogleG size={22} /> Read all reviews on Google
          </a>
        </Reveal>
      </div>
    </section>
  );
}
